/* Const,Let & Var will be here */
export const TM_VOUCHER_POPUP = 'TM_VOUCHER_POPUP'; 
export const SELECTED_TM_VOUCHER_DATA = 'SELECTED_TM_VOUCHER_DATA'; 
/* Const,Let & Var will be here */

export function setTmVoucherModelVisibility(selectedTMVoucher) {
    return {
        type: TM_VOUCHER_POPUP,
        setTmVoucherModelVisibility: selectedTMVoucher
    };
}

export function selectedTMVoucherData(selectedTMVoucher) {
    return {
        type: SELECTED_TM_VOUCHER_DATA,
        selectedTMVoucherData: selectedTMVoucher
    };
}